import WarningIcon from "assets/svg/warning-rounded.svg";
import PropTypes from "prop-types";
import { numberFormatter } from "helpers/number-formatter";

import styles from "./styles.module.css";

const ListingCount = ({ count }) => {
  const isCountOverThousand = count > 1000;
  let text = <div>{numberFormatter(count)} ilan gösteriliyor.</div>;
  if (isCountOverThousand) {
    text = (
      <div>
        {numberFormatter(count)} ilandan 1.000 tanesi gösteriliyor.
        <strong>Daha fazla ilan görebilmek için yaklaştırın.</strong>
      </div>
    );
  }
  const hasListings = <>{text}</>;
  const noListings = (
    <div className={styles.noListings}>
      <WarningIcon className={styles.warningIcon} />
      <p>
        Aradığınız kriterlere <b>uygun ilan bulunamadı.</b> Arama kriterlerinizi değiştirerek tekrar deneyebilirsiniz.
      </p>
    </div>
  );
  const listingCountText = count > 0 ? hasListings : noListings;
  return <div className={styles.listingsCountContainer}>{listingCountText}</div>;
};

ListingCount.propTypes = {
  count: PropTypes.number,
};

export default ListingCount;
